import styled from '../../../styles/styledComponents/themeComponents';

export const ImgContainerStyle = styled.div`
  overflow: hidden;

  .wrap-img {
    overflow: auto;
    display: flex;

    .sortable-list {
      display: flex;

      & > div {
        margin-right: 8px;
      }
    }
  }

  .register-img-wrap {
    position: relative;
    display: inline-block;
    margin-left: 0;

    &.hide {
      display: none;
    }

    .register-img {
      width: 140px;
      height: 140px;
      vertical-align: middle;
      text-align: center;
      overflow: hidden;
      position: relative;
      font-size: 40px;
      color: #c0c6d1;

      &:before {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border: 1px dashed #c1c5cd;
        content: ' ';
        height: 140px;
        width: 140px;
      }

      .add-btn {
        height: 140px;
        display: flex;
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;

        & > div {
          flex: 1 0 70px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .add-img-btn {
          border-right: 1px dashed #c1c5cd;
        }

        .only-video {
          width: 140px;
        }

        .anticon {
          margin: 0 auto;
          align-self: center;
          font-size: 40px;
          color: #c1c5cd;
        }
      }

      .file-input {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
        width: 140px;
        height: 140px;
        font-size: 0;
        cursor: pointer;

        &.can-add-video {
          width: 70px;
        }
      }
    }

    .form-explain {
      margin-top: 5px;
      color: #f5222d;
      font-size: 12px;
      font-weight: 500;
    }
  }
`;
